<template lang="pug">
div
  AuthHeader
  //- RewardNotificationLine(v-if="user_status === 'old'")
  main
    Promo.promo--bg-cover(:user="user_status", :promoLinks="promolinks")
  PromoFooter
  Registration(:showHeading="false")
  ReturningFriends(v-if="show_friend_block", :userStatus="user_status")
</template>

<script>
import UserMixin from "@chronos/frontend-base/src/mixins/user/UserMixin";
import AuthHeader from "@static_promo_pages/common/components/auth-header/vue/AuthHeader.vue";
import PromoFooter from "@static_promo_pages/common/components/footer/vue/Footer.vue";
import Registration from "@chronos/frontend-base/src/components/register/mygames/ProjectReg";
import Promo from "./blocks/promo/Promo";
import OldUserPopupMixin from "@static_promo_pages/common/components/old-user-popup/mixins/OldUserPopupMixin";
import ReturningFriends from "./blocks/ReturningFriends.vue";
// import RewardNotificationLine from "./blocks/RewardsNotificationLine";
import axios from "axios";
export default {
  name: "PromoIndex",

  components: {
    // RewardNotificationLine,
    Promo,
    AuthHeader,
    PromoFooter,
    Registration,
    ReturningFriends,
  },

  mixins: [UserMixin, OldUserPopupMixin],

  data() {
    return {
      promo_name: "universal",
      user_status: "not_authed",
      show_friend_block: false,
      promolinks: [],
    };
  },

  created() {
    document.addEventListener("init_vue_components", () => {
      this.initPromo();
      this.getUniversalBanners();
    });
  },

  methods: {
    getUniversalBanners() {
      axios.get("/api/promo_links/universal").then(response => {
        if (response.data.data) {
          this.promolinks = response.data.data;
        }
      });
    },

    async initPromo() {
      await this.$store.dispatch("global/auth", { profile_fields: ["registration_url"] });
      if (this.isUserInProject) {
        if (this.countDaysFromLastLogin >= 30) {
          this.user_status = "old";
        } else if (this.hasRegisteredHere) {
          this.user_status = "new";
        } else {
          this.user_status = "no_presents";
        }

        this.$nextTick(()=> {
          this.show_friend_block = true;
        });
      }
    },
  },
};
</script>
